import React from "react";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { CAMPS_OPEN } from "@/components/camps/campConfig";

const ctaClass =
  "mt-auto pt-10 inline-flex items-center gap-3 text-[#0F1B2D] text-[11px] tracking-[0.24em] uppercase font-bold group";

const CtaLabel = ({ children }) => (
  <span className="border-b border-[#C4A46A] pb-1 group-hover:text-[#C4A46A] transition-colors">{children}</span>
);

export const CampAction = ({ c, camp, onChoose }) => {
  if (camp.registerHref) {
    return (
      <a
        href={camp.registerHref}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`camp-register-external-${camp.slug}`}
        className={ctaClass}
      >
        <CtaLabel>{c.registerCta}</CtaLabel>
        <ArrowUpRight size={14} className="text-[#C4A46A]" />
      </a>
    );
  }
  if (CAMPS_OPEN) {
    return (
      <button type="button" onClick={() => onChoose(camp.slug)} data-testid={`camp-register-${camp.slug}`} className={ctaClass}>
        <CtaLabel>{c.registerCta}</CtaLabel>
        <ArrowRight size={14} className="text-[#C4A46A]" />
      </button>
    );
  }
  return (
    <div data-testid={`camp-opening-soon-${camp.slug}`} className="mt-auto pt-10">
      <span className="inline-flex items-center gap-2 px-4 py-2 text-[10px] tracking-[0.28em] uppercase font-bold border border-[#C4A46A] text-[#C4A46A] bg-transparent">
        <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#C4A46A] animate-pulse" aria-hidden="true" />
        {c.openingSoonCta}
      </span>
    </div>
  );
};
